import { Link } from 'react-router-dom';
import { useDarkHero } from '@/contexts/NavbarContext';

const countries = [
  'Almanya', 'Avusturya', 'Belçika', 'Bulgaristan', 'Çek Cumhuriyeti', 'Danimarka',
  'Estonya', 'Finlandiya', 'Fransa', 'Hırvatistan', 'Hollanda', 'İrlanda', 'İspanya',
  'İsveç', 'İtalya', 'Letonya', 'Litvanya', 'Lüksemburg', 'Macaristan', 'Malta',
  'Polonya', 'Portekiz', 'Romanya', 'Slovakya', 'Slovenya', 'Yunanistan', 'Kuzey İrlanda'
];

const features = [
  { icon: 'ri-file-text-line', title: 'A.TR Dolaşım Belgesi', desc: 'Avrupa Topluluğu ve Türkiye arasındaki Serbest Ticaret anlaşmasına istinaden düzenlenen resmi belge.' },
  { icon: 'ri-money-euro-circle-line', title: 'Gümrük Vergisi Muafiyeti', desc: '150 Euro üzeri değerlerde oluşan gümrük vergilerinden muaf tutulursunuz.' },
  { icon: 'ri-shield-check-line', title: 'Gümrük Muafiyeti', desc: 'Katma Protokol gereğince malların gümrük muafiyetinden yararlanabilmesini sağlar.' },
  { icon: 'ri-global-line', title: '27 AB Ülkesi', desc: 'Tüm Avrupa Birliği üyesi ülkelere yapılan ihracatta geçerli belge düzenliyoruz.' },
  { icon: 'ri-file-list-3-line', title: 'Resmi Onay', desc: 'İhracatçı ülke yetkilileri tarafından düzenlenerek gümrük idarelerince vize edilir.' },
  { icon: 'ri-customer-service-2-line', title: 'Uzman Destek', desc: 'A.TR belgesi süreçlerinde uzman ekibimiz her adımda yanınızda.' },
];

const requiredDocs = [
  'Taahhütname',
  'Gönderen firmanın Maliye Bakanlığı onaylı Türkçe resmi faturası (E-arşiv fatura zorunluluğu vardır)',
  'Faturada menşe bilgisi, kap adedi ve kilo bilgileri yer almalıdır',
  'Türk menşeli olmayan mallar için malın menşeini gösterir Gümrük Giriş Beyannamesi fotokopisi',
  '3. Ülke menşeli mallarda Gümrük vergisinin ödendiğine ilişkin Gümrük Vezne dekontu',
];

export default function AtrBelgesiPage() {
  useDarkHero(true);
  return (
    <main className="min-h-screen" style={{ background: 'var(--bg)' }}>
      {/* Hero */}
      <section className="relative min-h-[680px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=european%20union%20flag%20and%20turkish%20flag%20side%20by%20side%20with%20official%20trade%20documents%20and%20stamps%2C%20formal%20customs%20clearance%20concept%2C%20dark%20professional%20background%20with%20golden%20and%20orange%20lighting%2C%20international%20trade%20agreement%20visualization%2C%20cinematic%20documentary%20style&width=1920&height=680&seq=atr-hero-01&orientation=landscape"
            alt="A.TR Belgesi"
            loading="eager"
            fetchPriority="high"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(105deg, rgba(8,10,20,0.92) 0%, rgba(12,18,38,0.80) 55%, rgba(8,10,20,0.50) 100%)' }} />
        </div>

        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-20 w-80 h-80 rounded-full" style={{ background: 'var(--orange)', filter: 'blur(120px)' }} />
        </div>

        <div className="w-full max-w-6xl mx-auto px-6 lg:px-10 relative z-10 pt-36 pb-24">
          <div className="flex items-center gap-2 mb-8">
            <Link to="/hizmetler" className="text-sm hover:opacity-80 transition-opacity" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>Hizmetler</Link>
            <i className="ri-arrow-right-s-line" style={{ color: 'rgba(255,255,255,0.35)', fontSize: 14 }} />
            <span className="text-sm font-medium" style={{ color: 'var(--orange)' }}>A.TR Belgesi</span>
          </div>

          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-16">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ background: 'rgba(232,97,26,0.18)', border: '1px solid rgba(232,97,26,0.45)' }}>
                <i className="ri-file-text-line" style={{ color: 'var(--orange)' }} />
                <span className="text-sm font-semibold" style={{ color: 'var(--orange)' }}>A.TR Belgesi</span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                AB İhracatında<br />
                <span style={{ color: 'var(--orange)' }}>A.TR Dolaşım Belgesi</span>
              </h1>

              <p className="text-lg mb-8" style={{ color: 'rgba(255,255,255,0.82)', lineHeight: 1.8, maxWidth: 560 }}>
                Avrupa Topluluğu ve Türkiye arasındaki Serbest Ticaret anlaşmasına istinaden 27 AB ülkesine yapılan ihracatta gümrük muafiyeti sağlayan resmi dolaşım belgesi.
              </p>

              <div className="flex flex-wrap gap-4">
                <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
                  <i className="ri-mail-send-line" />Teklif Al
                </Link>
                <a href="tel:+908502420822" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold cursor-pointer whitespace-nowrap hover:opacity-80 transition-opacity" style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.28)', color: 'white', textDecoration: 'none' }}>
                  <i className="ri-phone-line" />0850 242 0 822
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 grid grid-cols-2 gap-3">
              {[{ val: '27', lbl: 'Ülke' }, { val: 'AB', lbl: 'Kapsamı' }, { val: '%0', lbl: 'Gümrük' }, { val: '150€+', lbl: 'Muafiyet' }].map((s, i) => (
                <div key={i} className="text-center px-8 py-6 rounded-2xl" style={{ background: 'rgba(255,255,255,0.09)', border: '1px solid rgba(255,255,255,0.18)', backdropFilter: 'blur(12px)' }}>
                  <div className="text-2xl font-bold mb-1" style={{ color: 'var(--orange)' }}>{s.val}</div>
                  <div className="text-xs" style={{ color: 'rgba(255,255,255,0.65)' }}>{s.lbl}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Info + Docs */}
      <section className="py-20" style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="p-8 rounded-2xl" style={{ background: 'var(--bg)', border: '1px solid var(--border)' }}>
              <h2 className="text-xl font-bold mb-4" style={{ color: 'var(--text1)' }}>A.TR Dolaşım Belgesi Nedir?</h2>
              <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--text3)' }}>
                Avrupa Topluluğu ve Türkiye arasındaki Serbest Ticaret anlaşmasına istinaden Avrupa Topluluğu&apos;na dahil ülkeler ile aramızdaki ticarette eşyaların serbest dolaşıma girebilmesi için düzenlenen belgedir.
              </p>
              <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--text3)' }}>
                Pek çok Avrupa Topluluğu ülkesi için gümrük vergileri 150 Euro üzeri değerlerde oluşur ve A.TR belgesi düzenlenmiş gönderiler bu vergiden muaf tutulur.
              </p>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text3)' }}>
                Avrupa Birliği&apos;ne yapılan sevkiyatta, Katma Protokol gereğince malların gümrük muafiyetinden yararlanabilmesi için &quot;A.TR Dolaşım Belgesi&quot;nin ihracatçı ülke yetkilileri tarafından düzenlenerek gümrük idarelerince vize edilmesi gerekir.
              </p>
            </div>
            <div className="p-8 rounded-2xl" style={{ background: 'var(--bg)', border: '1px solid var(--border)' }}>
              <h2 className="text-xl font-bold mb-4" style={{ color: 'var(--text1)' }}>Gerekli Belgeler</h2>
              <ul className="space-y-3">
                {requiredDocs.map((doc, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5" style={{ background: 'rgba(232,97,26,0.15)' }}>
                      <i className="ri-check-line text-xs" style={{ color: 'var(--orange)' }} />
                    </div>
                    <span className="text-sm leading-relaxed" style={{ color: 'var(--text3)' }}>{doc}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Countries */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="mb-12 p-8 rounded-2xl" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
            <h2 className="text-xl font-bold mb-6" style={{ color: 'var(--text1)' }}>A.TR Dolaşım Belgesinin Düzenleneceği Ülkeler</h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
              {countries.map((country, i) => (
                <div key={i} className="flex items-center gap-2 px-3 py-2 rounded-lg" style={{ background: 'var(--bg)', border: '1px solid var(--border)' }}>
                  <i className="ri-flag-line text-sm" style={{ color: 'var(--orange)' }} />
                  <span className="text-sm" style={{ color: 'var(--text2)' }}>{country}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div key={i} className="p-6 rounded-2xl" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-4" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${f.icon} text-xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <h3 className="font-bold text-sm mb-2" style={{ color: 'var(--text1)' }}>{f.title}</h3>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20" style={{ background: 'var(--surface)', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text1)' }}>A.TR Belgesi İçin Teklif Alın</h2>
          <p className="mb-8 text-sm" style={{ color: 'var(--text3)' }}>
            Farklı soru ve talepleriniz için uzman ekiplerimizden destek alabilirsiniz.<br />
            Destek hattı: <a href="tel:+908502420822" style={{ color: 'var(--orange)' }}>0850 242 0 822</a> – <a href="mailto:cs@cargonet.com.tr" style={{ color: 'var(--orange)' }}>cs@cargonet.com.tr</a>
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
              <i className="ri-mail-send-line" />Teklif Al
            </Link>
            <Link to="/hizmetler" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold cursor-pointer whitespace-nowrap" style={{ background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text1)', textDecoration: 'none' }}>
              <i className="ri-arrow-left-line" />Tüm Hizmetler
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
